import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { ECGComponentsModule } from '../../ecgcomponents/ecgcomponents.module'


import { SearchPage } from './search.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule, 
    ECGComponentsModule,
    RouterModule.forChild([
      {
        path: '',
        component: SearchPage
      }
    ])
  ],
  declarations: [
    SearchPage,
  ],
  entryComponents: [

  ]
})
export class SearchPageModule {}
